module.exports = __webpack_public_path__ + "static/whereVM-6d2458c0d3ec492f47887ce987d555ad.jpg";